<template>
  <footer>
    <div class="bg-black order-2 sm:order-1 text-NotoSansLight tracking-wider">
      <div class="container footer-main px-2 sm:px-6 md:px-16 lg:px-20 py-8 sm:py-10">
        <div class="flex flex-wrap">
          <div class="w-full md:hidden mb-10 sm:px-8">
            <h4 class="text-white text-center mb-5 text-s">CUSTOMER SERVICE</h4>
            <div class="w-full flex text-white text-center flex-wrap">
              <div class="w-1/3 sm:w-1/4 mb-6">
                <router-link :to="{ name: 'about'}" class="no-underline">
                  <div class="mb-4">
                    <img src="@/assets/icon/book-solid.png" alt="品牌故事" class="mx-auto">
                  </div>
                  <p class="whitespace-pre-wrap text-xs">品牌故事</p>
                </router-link>
              </div>
              <div class="w-1/3 sm:w-1/4 mb-6">
                <a class="no-underline text-white p-content cursor-pointer" target="_blank"
                  :href="smartPenUrl">
                  <div class="mb-4">
                    <img src="@/assets/icon/pen-solid.png" alt="點讀筆保固" class="mx-auto">
                  </div>
                  <p class="whitespace-pre-wrap text-xs">點讀筆保固</p>
                </a>
              </div>
              <div class="w-1/3 sm:w-1/4 mb-6">
                <router-link :to="{ name: 'service', params: { id: 'member' } }" class="no-underline">
                  <div class="mb-4">
                    <img src="@/assets/icon/question-circle-regular.png" alt="FAQ" class="mx-auto">
                  </div>
                  <p class="whitespace-pre-wrap text-xs">FAQ</p>
                </router-link>
              </div>
              <div class="w-1/3 sm:w-1/4 mb-6">
                <router-link :to="{ name: 'magazineSendBack' }" class="no-underline">
                  <div class="mb-4">
                    <img src="@/assets/icon/user-tag-solid.png" alt="雜誌訂戶服務" class="mx-auto">
                  </div>
                  <p class="whitespace-no-wrap text-xs">雜誌訂戶服務</p>
                </router-link>
              </div>
              <div class="w-1/3 sm:w-1/4 mb-6">
                <a href="https://school.liveabc.com/" class="no-underline" target="_blank">
                  <div class="">
                    <img src="@/assets/icon/icon1.png" alt="Live互動美語" class="mx-auto">
                  </div>
                  <p class="whitespace-pre-wrap text-xs">Live互動美語</p>
                </a>
              </div>
              <div class="w-1/3 sm:w-1/4 mb-6">
                <a class="no-underline text-white p-content cursor-pointer" target="_blank"
                  href="https://liveschool.liveabc.com/"
                  >
                  <div class="">
                    <img src="@/assets/icon/icon2.png" alt="LiveSchool" class="mx-auto">
                  </div>
                  <p class="whitespace-pre-wrap text-xs">LiveSchool</p>
                </a>
              </div>
              <div class="w-1/3 sm:w-1/4 mb-6">
                <a href="https://pro.liveabc.com/" class="no-underline" target="_blank">
                  <div class="">
                    <img src="@/assets/icon/icon3.png" alt="Livelearning" class="mx-auto">
                  </div>
                  <p class="whitespace-pre-wrap text-xs">Livelearning Pro</p>
                </a>
              </div>
              <div class="w-1/3 sm:w-1/4 mb-6">
                <a href="https://www.facebook.com/HowItWorksTW" class="no-underline" target="_blank">
                  <div class="">
                    <img src="@/assets/icon/icon4.png" alt="知識大圖解FB" class="mx-auto">
                  </div>
                  <p class="whitespace-no-wrap text-xs">知識大圖解<br/>粉絲團</p>
                </a>
              </div>
            </div>
          </div>
          <div class="w-1/2 md:w-1/4 pb-3 hidden md:block pr-3">
            <div class="flex flex-col">
              <div class="p-title mb-1">
                <p class="mb-0 p-title-text text-NotoSansBold text-white tracking-widest p-title-border">關於我們</p>
              </div>
              <router-link :to="{ name: 'about'}" class="no-underline text-white p-content">
                <p class="no-underline text-white mb-0 p-content-text font-normal">品牌故事</p>
              </router-link>
              <router-link :to="{ name: 'information'}" class="no-underline text-white p-content">
                <p class="no-underline text-white mb-0 p-content-text font-normal">公司資訊</p>
              </router-link>
              <router-link :to="{ name: 'privacy'}" class="no-underline text-white p-content">
                <p class="no-underline text-white mb-0 p-content-text font-normal">隱私權政策</p>
              </router-link>
              <router-link :to="{ name: 'policy'}" class="no-underline text-white p-content">
                <p class="no-underline text-white mb-0 p-content-text font-normal" >服務條款</p>
              </router-link>
              <a class="no-underline text-white p-content" href="https://latin-america.liveabc.com/" target="_blank">
                <p class="no-underline text-white mb-0 p-content-text font-normal" >Global Website</p>
              </a>
            </div>
          </div>
          <div class="w-1/2 md:w-1/4 pb-3 hidden md:block pr-3">
            <div class="flex flex-col">
              <div class="p-title mb-1">
                <p class="mb-0 p-title-text text-NotoSansBold text-white tracking-widest p-title-border">顧客服務</p>
              </div>
              <div @click="toMemberPage" class="no-underline text-white p-content cursor-pointer">
                <p class="no-underline text-white mb-0 p-content-text font-normal">會員專區</p>
              </div>
              <router-link :to="{ name: 'service', params: {id: 'member'}}" class="no-underline text-white p-content">
                <p class="no-underline text-white mb-0 p-content-text font-normal">常見Q&amp;A</p>
              </router-link>
              <router-link :to="{ name: 'magazineSendBack'}" class="no-underline text-white p-content">
                <p class="no-underline text-white mb-0 p-content-text font-normal">雜誌訂戶服務</p>
              </router-link>
              <a class="no-underline text-white p-content" target="_blank"
                :href="smartPenUrl"
                >
                <p class="no-underline text-white mb-0 p-content-text font-normal">點讀筆保固</p>
              </a>
              <!-- <a class="no-underline text-white p-content cursor-pointer" target="_blank"
                href="https://liveabc.site/docs">
                <p class="no-underline text-white mb-0 p-content-text font-normal">出版品內容更正</p>
              </a> -->
            </div>
          </div>
          <div class="w-full md:w-1/4 pb-3 px-3">
            <div class="flex flex-col items-center md:items-start">
              <div class="p-title mb-1">
                <p class="text-white mb-0 p-title-text text-NotoSansBold hidden md:block tracking-widest p-title-border">聯絡我們</p>
                <p class="text-white mb-0 p-title-text text-NotoSansBold md:hidden">CALL ME. &ensp;02-2578-7838</p>
              </div>
              <a class="no-underline p-content" href="mailto:service@liveabc.com">
                <p class="no-underline mb-0 p-content-text flex items-center">
                  <span class="md:hidden">service@liveabc.com</span>
                  <span class="hidden md:inline-block">客服信箱</span>
                  <svg focusable="false" data-prefix="far" data-icon="envelope" class="ml-2 h-5 w-5 svg-inline--fa fa-envelope fa-w-16" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                    <path style="fill:rgb(255, 255, 255);" fill="#AB7C94;" d="M464 64H48C21.49 64 0 85.49 0 112v288c0 26.51 21.49 48 48 48h416c26.51 0 48-21.49 48-48V112c0-26.51-21.49-48-48-48zm0 48v40.805c-22.422 18.259-58.168 46.651-134.587 106.49-16.841 13.247-50.201 45.072-73.413 44.701-23.208.375-56.579-31.459-73.413-44.701C106.18 199.465 70.425 171.067 48 152.805V112h416zM48 400V214.398c22.914 18.251 55.409 43.862 104.938 82.646 21.857 17.205 60.134 55.186 103.062 54.955 42.717.231 80.509-37.199 103.053-54.947 49.528-38.783 82.032-64.401 104.947-82.653V400H48z">
                    </path>
                  </svg>
                </p>
              </a>
              <a class="no-underline p-content flex items-center" href="https://lin.ee/wfB4HKN" target="_blank">
                <p class="no-underline mb-0 p-content-text items-center flex">
                  <span class="">LINE線上客服</span>
                </p>
                <div class="social-icon h-6 w-6 ml-2">
                  <img src="@/assets/icon/square-line.png" alt="LINE">
                </div>
              </a>
              <div class="no-underline p-content hidden md:block">
                <p class="no-underline mb-0 p-content-text">
                  02-2578-7838
                </p>
              </div>
              <div class="no-underline p-content">
                <p class="no-underline mb-0 p-content-text">
                  <span>周一至周五  8:30~17:30</span>
                </p>
              </div>
              <router-link :to="{ name: 'contact'}" class="no-underline p-content hidden md:block">
                <p class="no-underline mb-0 p-content-text">業務合作洽談</p>
              </router-link>
            </div>
          </div>
          <div class="w-full md:w-1/4 pt-8 md:pt-0">
            <div class="flex md:flex-col justify-center md:justify-start flex-wrap">
              <div class="p-title hidden md:block mb-1">
                <p class="mb-0 p-title-text text-NotoSansBold text-white tracking-widest p-title-border">社群連結</p>
              </div>
              <a class="flex items-end md:items-center no-underline hover:no-underline px-3 md:px-0"
                href="https://www.facebook.com/LiveABC/" target="_blank" aria-label="facebook">
                <div class="social-text hidden md:block">
                  <p class="no-underline mb-0">facebook</p>
                </div>
                <div class="social-icon h-6 w-6">
                  <img src="@/assets/icon/facebook.png" alt="facebook">
                </div>
              </a>
              <a class="flex items-end md:items-center no-underline hover:no-underline px-3 md:px-0"
                href="https://www.instagram.com/liveabc.official/" target="_blank" aria-label="Instagram">
                <div class="social-text hidden md:block">
                  <p class="no-underline mb-0">Instagram</p>
                </div>
                <div class="social-icon h-6 w-6">
                  <img src="@/assets/icon/instagram.png" alt="Instagram">
                </div>
              </a>
              <div class="mt-8 md:mt-4 max-w-sm search-container flex items-center justify-start bg-white w-4/5 rounded focus:outline-none overflow-hidden" tabindex="0" v-if="!authorized || (authorized && user && !user.isAgreeReceiveDM)">
                <input placeholder="輸入E-MAIL獲得優惠訊息" type="email" class="pl-2 m-0 text-xs focus:outline-none w-full"
                  v-model="emailaddress" v-on:keyup.13="subscription" aria-label="訂閱電子報" id="newsletter" autocomplete="off">
                <div class="searchButton px-3 py-1 text-white bgLiveMainBlack whitespace-no-wrap block cursor-pointer" @click.prevent="subscription">
                  送出
                </div>
              </div>
            </div>
          </div>
          <div class="w-full lg:w-1/4 lg:hidden footer-copyright">
            <span class="mx-auto table mb-0 pt-8 pb-20 text-white text-center">Copyright © 2019 Hebron Soft Limited All Rights Reserved.</span>
          </div>
        </div>
      </div>
    </div>

    <div class="footer-copyright hidden lg:block">
      <div class="w-full">
        <span class="mx-auto table mb-0 py-8 text-center">Copyright © 2019 Hebron Soft Limited All Rights Reserved.</span>
      </div>
    </div>
  </footer>
</template>

<script>
import Regex from '../modules/regex'
import axios from 'axios'
import { mapGetters } from 'vuex'
import sweetAlert from '@/components/modules/sweetAlert'
export default {
  name: 'footerSection',

  data () {
    return {
      emailaddress: null,

      smartPenUrl: 'https://docs.google.com/forms/d/e/1FAIpQLScHZIm2IoSTzjX6BjfuJtgvIhFiPuMye73afMJnYtar5DLeMA/viewform'
    }
  },
  mixins: [
    Regex,
    sweetAlert
  ],
  computed: {
    ...mapGetters([
      'authorized',
      'user'
    ])
  },
  methods: {
    toMemberPage () {
      let self = this
      if (!self.$store.getters.authorized) {
        self.$router.push({ name: 'login' })
      } else {
        self.$router.push({ name: 'order' })
      }
    },
    subscription () {
      let self = this
      if (self.emailaddress && self.rexEmail(self.emailaddress)) {
        let path = '/subscribe/epaper/' + self.emailaddress
        axios.post(path)
          .then((response) => {
            if (response.data.status === 'Subscribed') {
              self.alertPop('success', '已訂閱電子報')
              // self.$store.dispatch('updateAlert', { isAlert: true, isHead: true, alertMsg: '已訂閱電子報', type: 'check' })
              self.emailaddress = null
            } else {
              self.alertPop('success', '請至信箱點選認證信')
              // self.$store.dispatch('updateAlert', { isAlert: true, isHead: true, alertMsg: '請至信箱點選認證信', type: 'check' })
            }
          })
          .catch(() => {
            self.alertPop('info', '您已經訂閱')
            // self.$store.dispatch('updateAlert', { isAlert: true, isHead: true, alertMsg: '您已經訂閱', type: 'alert' })
            self.emailaddress = null
          })
      }
    }
  }
}
</script>
<style lang="scss" scoped>
footer {
  .footer-main {
    .p-title {
      height: 32px;
      p {
        line-height: 32px;
        font-size: .875rem;
      }
      .p-title-border {
        // border-bottom: 1px solid white;
        position: relative;
        &::after {
          content: '';
          position: absolute;
          width: 10em;
          height: 1px;
          bottom: 0;
          left: 0;
          border-bottom: 1px solid white;
          @media (min-width: 1024px) {
            width: 12em;
          }
          @media (min-width: 1440px) {
            width: 16em;
          }
        }

      }
    }
    .p-content {
      min-height: 32px;
      .p-content-text {
        font-weight: 400;
        line-height: 32px;
        font-size: .875rem;
        color: #ffffff;
      }
    }
    .social-text {
      width: 85px;
      min-height: 32px;
      p {
        font-weight: 400;
        line-height: 32px;
        font-size: .875rem;
        color: #ffffff;
      }
    }
  }

  .footer-copyright {
    span {
      font-size: 12px !important;
    }
  }
    @media (max-width: 577px) {
      .footer-copyright {
        span {
          font-size: 10px !important;
        }
      }
    }
}
</style>
